<template>
  <span v-if="badge" class="sidebar-badge" :class="`sidebar-badge--${badge.type}`">
    <template v-if="badge.type === 'count'">
      {{ displayValue }}
    </template>
    <svg
      v-else-if="badge.type === 'stop'"
      viewBox="0 0 24 24"
      class="sidebar-badge__stop-sign"
    >
      <!-- Дорожный знак СТОП: восьмиугольник с белой окантовкой -->
      <polygon
        points="7.6,1.5 16.4,1.5 22.5,7.6 22.5,16.4 16.4,22.5 7.6,22.5 1.5,16.4 1.5,7.6"
        fill="#ff005f"
        stroke="#ffffff"
        stroke-width="1.6"
        stroke-linejoin="round"
      />
      <text
        x="12"
        y="12"
        text-anchor="middle"
        dominant-baseline="central"
        fill="#ffffff"
        font-size="5.6"
        font-weight="700"
        font-family="Arial, sans-serif"
      >STOP</text>
    </svg>
  </span>
</template>

<script>
  export default {
    name: 'SidebarBadge',
    props: {
      // { type: 'count', value: n } | { type: 'stop' } | null
      badge: {
        type: Object,
        default: null,
      },
    },
    computed: {
      displayValue () {
        const value = this.badge?.value || 0
        return value > 99 ? '99+' : String(value)
      },
    },
  }
</script>

<style lang="less" scoped>
.sidebar-badge {
  position: absolute;
  top: -5px;
  right: -8px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  &--count {
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    border-radius: 9px;
    background-color: #ff005f;
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    line-height: 18px;
  }

  &--stop {
    width: 22px;
    height: 22px;
  }

  .sidebar-badge__stop-sign {
    width: 100%;
    height: 100%;
    display: block;
  }
}
</style>
